var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-page-component-container"},[_c('div',{staticClass:"component-wrapper"},[_c('div',{staticClass:"maintenance-page-container"},[_c('div',{staticClass:"maintenance-text-container"},[_c('p',[_vm._v(_vm._s(_vm.$t('application_under_construction')))])])]),_c('LoginFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }